module.exports = __webpack_public_path__ + "img/right-btn.ee266135.png";